import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs';

/**
 * Some components (notification panel) need the height of the page content.
 *
 * It is up to AppComponent to broadcast the height because we cannot use document.element.height.
 *
 * @export
 * @class ContentHeightService
 */
@Injectable({
  providedIn: 'root'
})
export class ContentHeightService {

  /**
   * Use an rxjs Subject to broadcast the height.
   *
   * @private
   * @type {Subject<number>}
   * @memberof ContentHeightService
   */
  private subject: Subject<number> = new Subject<number>();

  /**
   * Get the height by subscribing to this observable.
   *
   * @type {Observable<number>}
   * @memberof ContentHeightService
   */
  public contentHeight$: Observable<number> = this.subject.asObservable();

  /**
   * Creates an instance of ContentHeightService.
   * @memberof ContentHeightService
   */
  constructor() { }

  /**
   * Let AppComponent update the height.
   *
   * @param {number} height 
   * @memberof ContentHeightService
   */
  setHeight(height: number): void {
    this.subject.next(height);
  }

}
